import React from 'react'
import Nav from '../Components/Outlets/Nav'
import why from '../Assets/why.svg'
import quran from '../Assets/quran.svg'
import Footer from '../Components/Outlets/Footer'

const Acadamics = () => {
	return (
		<div>
			<Nav />
			<div class="about-page-main">
				<div className="path-menus acadamics-page">
					<div className="container-main">
						<h2 class="page-heading-name mb-0">Acadamics</h2>
					</div>
				</div>
			</div>
			<div className="acadamics-page-box">
				<div className="container-main">
					<div className="row">
						<div className="col-lg-6">
							<div className="acadamics-inner">
								<h2 className='chairman-text'>Why QGarden</h2>
								<p className='text-about-sub'>Q-Garden is the scriptural abode for women that is driven by ‘ women empowerment through education’ maxim. This insti- tution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of mod- ern threat to motherhood and deprived childhood.</p>
								<p className='text-about-sub'>Women empowerment is universal aim which has been called for since antiqui- ty. We believe in the power of education in flourishing that aim as true knowledge leads to both spiritual and physical emancipation. Rose garden develops a one stop centre that amalgamates versatile knowledge im- parts with focusing equally on self transfor- mation.</p>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="acadamics-inner">
								<img src={why} className="acad-img" alt="" />
							</div>
						</div>
						<div className="col-lg-12">
							<div className="memmorisation-dv">
							<h2 className='chairman-text'>Memmorisation</h2>
							<img src={quran} className="quran-img" alt="" />
							<p className='text-about-sub '>Q-Garden is the scriptural abode for women that is driven by‘ women empowerment through education’ maxim. This institution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of modern threat to motherhood and deprived childhood. Q-Garden is the scriptural abode for women that is driven by‘ women empowerment through education’ maxim. This institution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of modern threat to motherhood and deprived childhood.</p>
							{/* <p className='text-about-sub'>Q-Garden is the scriptural abode for women that is driven by‘ women empowerment through education’ maxim. This institution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of modern threat to motherhood and deprived childhood.</p> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		<Footer />
		</div>
	)
}

export default Acadamics